import { Component, computed, inject, signal, Signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegistrationListComponent } from '../registration-list/registration-list.component';
import { MatButton } from '@angular/material/button';
import { UserService } from '../../../services/api-services/user.service';
import { Toolchain } from '../../../utils/models/toolchain.models';
import { ToolchainService } from '../../../services/api-services/toolchains/toolchain.service';

@Component({
  selector: 'app-tool-registration-dialog',
  templateUrl: './toolchain-registration-dialog.component.html',
  styleUrls: ['./toolchain-registration-dialog.component.scss'],
  imports: [RegistrationListComponent, MatButton],
})
export class ToolchainRegistrationDialogComponent {
  /** Inject services. */
  private readonly dialogRef =
    inject<MatDialogRef<ToolchainRegistrationDialogComponent>>(MatDialogRef);
  private readonly toolchainService = inject(ToolchainService);
  private readonly userService = inject(UserService);
  private readonly toolchain = inject<Signal<Toolchain>>(MAT_DIALOG_DATA);

  /** Request resources. */
  readonly registrations = this.toolchainService.getRegistrations();
  readonly users = this.userService.getAllUsers();

  toolchainRegistration = computed(() => {
    const filteredRegistrations =
      this.registrations
        .value()
        ?.filter(
          registration => registration.toolchain.toolchainId == this.toolchain().toolchainId
        ) ?? [];
    const selectedUsers = [];
    for (const registration of filteredRegistrations) {
      selectedUsers.push(registration.user);
    }
    return { toolchain: this.toolchain(), users: selectedUsers };
  });

  isLoading = signal(false);

  selectedItems: number[] = [];

  cancel() {
    this.dialogRef.close();
  }

  updateItems(ids: number[]) {
    this.selectedItems = ids;
  }

  async apply() {
    this.isLoading.set(true);
    const userIds = this.selectedItems;
    const promises: Promise<{ result: string }>[] = [];
    for (const userId of userIds) {
      if (!this.toolchainRegistration().users.some(el => el.userId === userId)) {
        promises.push(
          this.toolchainService.updateRegistration(
            userId,
            this.toolchainRegistration().toolchain.toolchainId
          )
        );
      }
    }

    for (const user of this.users.value() ?? []) {
      if (
        !userIds.some(el => el === user.userId) &&
        this.toolchainRegistration().users.some(el => el.userId === user.userId)
      ) {
        promises.push(
          this.toolchainService.deleteRegistration(
            user.userId,
            this.toolchainRegistration().toolchain.toolchainId
          )
        );
      }
    }

    await Promise.all(promises);
    this.dialogRef.close();
  }
}
